import { iUploadeImagesList } from './imageUpload';

/* 查询 */
export interface iVirtualKeyBoardQuery {
  name: string;
  file_id: string;
  uname_id: string;
  file_type: number;
  has_update: number;
  order_by: number;
  order_rule: number;
  page_type: eUpdateType;
  audit_status: number;
}

/* 详情 */
export interface iVirtualKeyBoard {
  sort: number;
  file_id: number;
  name: string;
  file_type_name: string;
  preview: object;
  update_preview: object;
  like_num: number;
  used_num: number;
  status: number;
  uname: string;
  uid: number;
  has_update: number;
  approval_time: string;
  upload_time: string;
  update_time: string;
  agree_update_time: string;
  update_preview_name: string;
}
/* 排序 升序(up)还是降序(down),大小写不敏感*/
export interface iSort {
  id: number;
  sort: string;
  version: number;
}
//上传类型
export enum eUpdateType {
  /**
   * 官方推荐
   */
  OFFICIAL = 0,
  /**
   *网友推荐
   */
  NETFRIEND = 1,
  /**
   * 待审核
   */
  PENDINGREVIEW = 2,
}
//上传类型
export enum eSortField {
  /**
   * 默认排序
   */
  DEFAULT = 0,
  /**
   *展示排序
   */
  UV = 1,
  /**
   * 点赞数
   */
  LIKE_NUM = 2,
  /**
   * 使用次数used_num
   */
  USED_NUM = 3,
}

export enum eUpdateState {
  /**
   *更新通过
   */
  PASS = 1,
  /**
   * 更新拒绝
   */
  REJECT = 2,
}

export enum eAuditState {
  /**
   *审核通过
   */
  PASS = 0,
  /**
   * 审核拒绝
   */
  REJECT = 1,
}
